export const ENV = {
  // REACT_APP_BASE_URL: 'http://localhost:4000',
  REACT_APP_BASE_URL: 'https://kastafioreapi.etude-tabapsy.fr',
  REACT_APP_BASE_URL_MOCK: 'https://ebc36566-93e2-4300-b2ec-9a353debbbe7.mock.pstmn.io',
  VAPID_PUBLIC_KEY: "BP6xaq0wOLB8w368ESw6jWyjKZD7Us5TgtjNdt3_ezpZXhH2DLhOpuXkh3KDnPNn-JavIbbU7HslBopce-XObDw",
}
